<template>
  <div>
    <v-select
      v-model="selectedRejectReason"
      :label="label"
      :items="dropdownItems"
      :rules="required ? rules.rejectReason : []"
      variant="outlined"
      :readonly="readonly"
      :disabled="disabled"
      v-bind="$attrs"
      v-on="$listeners"
      clearable
    ></v-select>

    <v-text-field
      v-if="showOtherField"
      v-model="otherRejectReason"
      :label="otherReasonLabel"
      :rules="required ? rules.otherRejectReason : []"
      variant="outlined"
      :readonly="readonly"
      :disabled="disabled"
      v-bind="$attrs"
      v-on="$listeners"
    ></v-text-field>
  </div>
</template>

<script>
import ValidationService from "@/gapp-components/services/validation.service.js";

export default {
  name: "RejectionReasonField",
  props: {
    label: {
      type: String,
      default: "Select Reason for Rejection"
    },
    otherReasonLabel: {
      type: String,
      default: "Other Reason for Rejection"
    },
    allowOther: {
      type: Boolean,
      default: false
    },
    selectedRejectReasonValue: {
      type: String,
      default: null
    },
    rejectReason: {
      type: String,
      default: ""
    },
    rejectionType: {
      type: String,
      default: ""
    },
    required: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedRejectReason: this.selectedRejectReasonValue,
      otherRejectReason: this.rejectReason,
      arrayRejectClaimReasons: [],
      rules: {
        rejectReason: ValidationService.generateDropdownValidationRules(this.label),
        otherRejectReason: ValidationService.generateTextValidationRules(this.otherReasonLabel, 200)
      }
    };
  },
  computed: {
    dropdownItems() {
      return this.allowOther ? [...this.arrayRejectClaimReasons, "Other"] : this.arrayRejectClaimReasons;
    },
    showOtherField() {
      return this.allowOther && this.selectedRejectReason === "Other";
    }
  },
  methods: {
    fetchRejectionData() {
      const filters = {
        rejectionType: { name: this.rejectionType }
      };
      this.$api.post(`/api/rejectionReasons/search`, filters).then(({ data }) => {
        this.arrayRejectClaimReasons = data?.content?.map(item => item.reason) || [];
      });
    },
    handleRejectionChange() {
      this.$emit("update:selectedRejectReason", {
        selectedRejectReasonValue: this.selectedRejectReason,
        rejectReason: this.otherRejectReason
      });
    }
  },
  watch: {
    selectedRejectReasonValue(newVal) {
      this.selectedRejectReason = newVal;
    },
    selectedRejectReason(newVal) {
      if (newVal !== "Other") {
        this.otherRejectReason = "";
      }
      this.handleRejectionChange();
    },
    otherRejectReason() {
      this.handleRejectionChange();
    }
  },
  mounted() {
    this.fetchRejectionData();
  }
};
</script>

<style scoped>
/* Add styles if needed */
</style>
